import moment from 'moment';

export function getCalenderInterval(timeFilterSelections) {
    if (timeFilterSelections.endDateTime && timeFilterSelections.startDateTime) {
        let endDate = moment(timeFilterSelections.endDateTime);
        let startDate = moment(timeFilterSelections.startDateTime);
  
        let days = endDate.diff(startDate, 'days');
        if(days <= 7){
          return "1d";
        }else if (days <= 92){
          return "1w";
        }else if (days <= 365){
          return "1M";
        }else if (days > 365){
          return "1q";
        }      
      }
      else {
        return "";
      }
    }